import { Component } from '@angular/core';

@Component({
  selector: 'app-full-logo',
  templateUrl: './full-logo.component.html',
  styleUrls: ['./full-logo.component.css']
})
export class FullLogoComponent {

}
